import { Layout } from "antd";
const { Footer } = Layout;
export const FooterNav = ({ ...props }) => {
  return <Footer {...props}>Aleman company SAC @2025</Footer>;
};
